var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMoreActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10.5,
    cy: 10.5,
    r: 10,
    stroke: "rgba(255, 87, 51, 1)",
    strokeWidth: 1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.47969 14.1469L9.18637 14.8535L13.54 10.4979L9.1867 6.14655L8.47969 6.85389L12.126 10.4982L8.47969 14.1469Z",
    fill: "#ED7037"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoreActive);
export default __webpack_public_path__ + "static/media/moreActive.62aaa5af2263da7870f5f8c2b8e1faaf.svg";
export { ForwardRef as ReactComponent };